import "./assets/css/App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layouts/admin";
import React from "react";
import theme from "theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import { ChakraProvider } from "@chakra-ui/react";
import initialTheme from "./theme/theme";
import { useState, useEffect } from "react";
import Login from "pages/auth/signIn";
import PatientDetail from "pages/patients/detailsPatient";
import UpdatePatient from "pages/patients/updatePatient";
import Patients from "pages/patients";
import UserProfile from "pages/admin/profile";
import Users from "pages/user";
import UserDetail from "pages/user/detailsUser";
import UpdateUser from "pages/user/updateUser";
import Layout from "layouts/Layout";
import RequireAuth from "pages/auth/components/RequireAuh";
import Dashboard from "pages/admin/home";
import Visits from "pages/visits";
import Settings from "pages/admin/settings";
import VisitDetails from "pages/visits/detailsVisit";
import UpdateVisit from "pages/visits/updateVisit";
import { useDispatch } from "react-redux";
import { setCsrfToken } from "pages/auth/csrfSlice";
import { fetchCsrfToken } from "store/apis/csrfApi";
import { HelmetProvider } from "react-helmet-async";
import Labs from "pages/labs";
import Prescriptions from "pages/prescription";
import PrescriptionDetails from "pages/prescription/detailsPrescription";
import PrescriptionUpdate from "pages/prescription/updatePrescription";
import LabDetails from "pages/labs/detailsLab";
import LabUpdate from "pages/labs/updateLab";
import License from "pages/admin/settings/license";
import Appointments from "pages/appointment";
import AppointmentDetail from "pages/appointment/detailsAppointment";
import AppointmentUpdate from "pages/appointment/updateAppointment";
import Terms from "pages/admin/settings/terms";
import AllVisits from "pages/visits/allVisits";

export default function Main() {
    const dispatch = useDispatch();
    const initializeCsrf = async () => {
        try {
            const token = await fetchCsrfToken();
            dispatch(setCsrfToken(token));
            // console.log("CSRF token fetched and set:", token);
        } catch (error) {
            console.error("Failed to initialize CSRF token:", error);
        }
    };

    useEffect(() => {
        initializeCsrf();
    }, []);

    const [currentTheme, setCurrentTheme] = useState(initialTheme);

    return (
        <ChakraProvider theme={theme}>
            <ThemeEditorProvider>
                <HelmetProvider>
                    <Routes>
                        <Route path="/" element={<Layout />}>
                            <Route path="login" element={<Login />} />
                            <Route element={<RequireAuth />}>
                                <Route
                                    path="/home"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Dashboard />}
                                            pageName="Dashboard"
                                        />
                                    }
                                />

                                <Route
                                    index
                                    element={<Navigate to="/home" replace />}
                                />

                                <Route
                                    path="/profile"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<UserProfile />}
                                            pageName="Profile"
                                        />
                                    }
                                />

                                <Route
                                    path="/settings"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Settings />}
                                            pageName="Settings"
                                        />
                                    }
                                />

                                <Route
                                    path="/users"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Users />}
                                            pageName="Users"
                                        />
                                    }
                                />

                                <Route
                                    path="user/:id/details"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<UserDetail />}
                                            pageName="Details"
                                        />
                                    }
                                />

                                <Route
                                    path="user/:id/update"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<UpdateUser />}
                                            pageName="Update"
                                        />
                                    }
                                />

                                <Route
                                    path="/patients"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Patients />}
                                            pageName="Patients"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:id/details"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<PatientDetail />}
                                            pageName="Details"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:id/update"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<UpdatePatient />}
                                            pageName="Update"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/visits"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Visits />}
                                            pageName="Visits"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/visits/:visitId/details"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<VisitDetails />}
                                            pageName="Visit Details"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/visits/:visitId/update"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<UpdateVisit />}
                                            pageName="Update Visit"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/labs"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Labs />}
                                            pageName="Labs"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/labs/:labId/details"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<LabDetails />}
                                            pageName="Lab Details"
                                        />
                                    }
                                />
                                <Route
                                    path="patients/:patientId/labs/:labId/update"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<LabUpdate />}
                                            pageName="Lab Update"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/prescriptions"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Prescriptions />}
                                            pageName="Prescriptions"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/prescriptions/:presId/details"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<PrescriptionDetails />}
                                            pageName="Prescription Details"
                                        />
                                    }
                                />

                                <Route
                                    path="patients/:patientId/prescriptions/:presId/update"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<PrescriptionUpdate />}
                                            pageName="Prescription Update"
                                        />
                                    }
                                />

                                <Route
                                    path="/license"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<License />}
                                            pageName="License"
                                        />
                                    }
                                />

                                <Route
                                    path="appointments/:id/details"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<AppointmentDetail />}
                                            pageName="Appoinment Detail"
                                        />
                                    }
                                />

                                <Route
                                    path="appointments/:id/update"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<AppointmentUpdate />}
                                            pageName="Appoinment Update"
                                        />
                                    }
                                />

                                <Route
                                    path="appointments"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Appointments />}
                                            pageName="Appoinments"
                                        />
                                    }
                                />

                                <Route
                                    path="terms"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<Terms />}
                                            pageName="Terms"
                                        />
                                    }
                                />

                                <Route
                                    path="visits"
                                    element={
                                        <AdminLayout
                                            theme={currentTheme}
                                            setTheme={setCurrentTheme}
                                            content={<AllVisits />}
                                            pageName="All Visits"
                                        />
                                    }
                                />
                            </Route>
                        </Route>
                    </Routes>
                </HelmetProvider>
            </ThemeEditorProvider>
        </ChakraProvider>
    );
}
